export default {
  tab: {
    dashboard: 'HM Dashboard'
  },
  title: {
    dashboard: 'My Candidate Screening & Interview Portal',
    rating: 'Candidate Screening Rating Form',
    interview: 'Candidate Interview Rating Form'
  },
  containerTitle: {
    dashboard: {
      candidateInterviews: 'Candidate Interview',
      candidateScreening: 'Candidate Screening'
    }
  },
  placeholder: {
    candidateName: 'Candidate Name'
  },
  label: {
    recruiter: 'Recruiter',
    candidate: 'Candidate',
    status: 'Status',
    actions: 'Actions',
    dateJObEntity: 'Date / Job / Entity',
    toDo: 'Scheduled',
    toInterviewed: 'Need Rating',
    completed: 'Rating Finished',
    canceled: 'Canceled',
    tabToRate: 'To Rate',
    tabToInterview: 'To Interview',
    tabCompleted: 'Completed',
    tabCanceled: 'Canceled',
    userName: 'Email Address',
    firstName: 'First Name',
    lastName: 'Last Name',
    password: 'Password',
    createPassword: 'Create Your Password',
    rePassword: 'Re-Enter Password',
    forgetPassword: 'Forgot Password',
    rating: {
      notRecommended: "Don't Recommend For Interview",
      Recommended: 'Recommend For Interview',
      commentTips: 'Please review the previous comments, then click NEXT to move on to the next step.',
      ratingTips: 'Please rate accordingly',
      overallTips: 'Please add your comments and make your overall evaluation.'
    },
    pending: 'Pending',
    interview: {
      notRecommended: 'Not Recommended',
      Recommended: 'Recommended',
      commentTips: 'Please review the previous comments, then click NEXT to move on to the next step.',
      ratingTips: 'Please rate accordingly',
      overallTips: 'Please add your comments and make your overall evaluation.'
    },
    questionLabel: 'Question:',
    answerLabel: 'Answer:',
    ratingLabel: 'Rating:',
    commentLabel: 'Comments:',
    tab: {
      rating: {
        comments: 'Comments',
        resume: 'Resume',
        report: 'Report',
        rating: 'Rating',
        overall: 'Evaluation'
      },
      interview: {
        comments: 'Comments',
        resume: 'Resume',
        report: 'Report',
        rating: 'Rating',
        overall: 'Evaluation'
      }
    },
    comment: 'Comment',
    organizer: 'Organizer'
  },
  resume: {
    aiResumeMatchInfo: 'AI Fit Score',
    aiSummaryInfo: 'AI Resume Summary',
    basicInfo: 'Basic Info',
    originalResume: 'Original Resume',
    applyFor: 'Apply for',
    jobApplicationDate: 'Job applied date',
    legalName: 'Legal name',
    emailAddress: 'Email address',
    mobileId: 'Mobile id',
    stlutation: 'Salutation',
    birthday: 'Birthday',
    gender: 'Gender',
    location: 'Home location',
    currentLocation: 'Current location',
    address: 'Address',
    addressOther: 'Address(Other - if have)',
    mobilePhone: 'Mobile phone',
    secondPhone: 'Second phone',
    chatId: 'Chat id',
    socialNetwork: 'Social network(s)',
    expectedSalary: 'Expected salary',
    applicantQuestionnaire: 'Applicant Questionnaire',
    hrQuestionnaire: 'Recruiter Screening',
    specificQuestions: 'Specific Questions',
    question: 'Question:',
    video: 'Video:',
    attachment: 'Attachment:',
    remark: 'Note:',
    answer: 'Answer:',
    referredBy: 'Referred by',
    referralReson: 'Referral Reson',
    employee: 'Employee',
    notEmployee: 'Non-Employee',
    intern: 'Intern / Part Time Experience',
    experience: 'Experience',
    education: 'Education',
    additionalInfo: 'Additional Info',
    hiringManagerRating: 'Hiring Manager(s) Rating',
    workExperience: {
      company: 'Company',
      jobTitle: 'Title',
      industry: 'Industry',
      locaton: 'Locaton',
      date: 'Date',
      salary: 'Salary',
      description: 'Description',
      year: '{year} year',
      month: '{month} month'
    },
    educationInfoLabel: {
      school: 'School',
      degree: 'Degree and Major',
      date: 'Date',
      gpa: 'GPA',
      academic: 'Academic rating',
      other: 'Other',
      summary: 'Summary'
    },
    additionInfoLabel: {
      memberships: 'Professional memberships',
      awards: 'Awards',
      hobby: 'Hobby',
      lanaguages: 'Lanaguages',
      channel: 'Application channel',
      platform: 'Job application platform'
    },
    referralRoleType: {
      employee: 'Employee',
      candidate: 'Candidate',
      lead: 'Lead',
      prospect: 'Prospect'
    }
  },
  btn: {
    dashboard: {
      preview: 'Preview',
      rate: 'Rate',
      view: 'View',
      reschedule: 'Reschedule',
      cancel: 'Cancel'
    },
    toHMDashboard: 'Login',
    submit: 'Submit',
    reset: 'Reset',
    signOnt: 'Sign Out',
    homePage: 'Dashboard',
    next: 'Next',
    back: 'Back',
    resend: 'Resend my login details',
    download: 'Download',
    expand: 'Expand',
    collapse: 'Collapse'
  },
  status: {
    dashboard: {
      comingUp: 'Scheduled',
      needRating: 'Need Rating',
      finish: 'Rating Finished',
      cancel: 'Canceled'
    }
  },
  tips: {
    dashboard: {
      cancel: 'To cancel, please contact',
      reschedule: 'To reschedule, please contact',
      noData: 'Currently there are no invitation records.'
    },
    pleaseRate: 'Please rate',
    invitcodeError: 'Invitation code is incorrect, will return to the home page!',
    ratingSuccess: 'Rating success, will return to the home page!',
    pleaseSelect: 'Please Select'
  },
  interviewInvitation: {
    title: 'Interview Scheduler',
    label: {
      information: 'Interview Information: ',
      company: 'Company',
      job: 'Job',
      organizer: 'Organizer',
      interviewer: 'Interviewer',
      candidate: 'Candidate',
      status: 'Status',
      selectTime: 'Please select three time slots, which will be shared with the candidates: ',
      singleTime: 'Please select a time slot that will be shared with the candidate: ',
      timeZone: 'Time Zone:',
      interviewTime: 'Interview Time:',
      candidateSelectTime: 'Pending - Candidate select interview time',
      cancelInterview: 'Do you confirm to cancel the interview?',
      candidateSuggestedNewTime: 'Candidate requests new times',
      interviewerSuggestedNewTime: 'New interview times proposed',
      canceled: 'Interview canceled',
      interviewConfirm: 'Please confirm the final interview information',
      reschedulingByCandidate: 'Current interview time:',
      reschedulingByInterviewer: 'New interview times proposed:',
      teamsTip: 'Click the send button to create a Teams link and send the final interview invitation email.'
    },
    message: {
      duplicateDateTime: 'Duplicate time slot selected. Please re-select.',
      confirmSuccess: "Your availability has been sent to the candidate. We'll notify you once they confirm a time. Need to make changes? Use the link in your email anytime.",
      pendingHrConfirm: "Successfully sent. Please wait for the organizer's confirmation.",
      cancelSuccess: 'Interview Canceled Successfully',
      selectInterviewTime: 'Please select at least one time slot.',
      sendSuccess: 'Successfully sent.',
      maxSelectScheduleCount: 'You can only select up to {maxCount} time slots.',
      placeChangePC: 'This interview is a Teams interview, please operate on the PC terminal'
    },
    btn: {
      suggestNewTime: 'Suggest New Time',
      reschedule: 'Reschedule',
      send: 'Send'
    }
  }
}
